export default __webpack_public_path__ + "static/media/burger.5f834ce8.webp";